var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPlanOnboarding2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 56,
    r: 42,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.18 42.621h-3V39.63a.82.82 0 0 0-.82-.82h-2.998v-2.99a.83.83 0 0 0-.82-.82H32.82a.82.82 0 0 0-.82.82v32.648a.83.83 0 0 0 .82.82h2.998v2.99c0 .453.367.82.82.82h3v2.992c0 .453.368.82.82.82H73.18a.82.82 0 0 0 .82-.82V43.442a.82.82 0 0 0-.82-.82M45.71 67.648l5.775-5.762 3.149-3.142 4.292 4.283-4.632 4.621zm-10.906 0 8.923-8.903 4.293 4.28-4.634 4.623zM64.72 57.245l-4.635 4.622-4.29-4.282 8.925-8.906zm-15.54 4.622-4.293-4.28 9.747-9.726 4.29 4.283-4.868 4.858-.004.003-.003.004-3.723 3.715zM33.64 48.68l3.47 3.465-3.47 3.464zm10.085-.819 4.293 4.284-4.85 4.84-.023.02-4.873 4.863-4.291-4.282 4.87-4.86.011-.012zm6.034-6.018 4.874-4.863 4.292 4.283-4.848 4.838-.025.022-.02.023-4.852 4.84-4.294-4.283 4.861-4.85zM37.112 63.026 33.64 66.49v-6.929zM64.72 46.36l-4.635 4.625-4.29-4.283 8.925-8.905zm-4.634-6.258-3.47-3.462h6.94zm-16.94 6.018-4.874 4.864-4.291-4.283 9.744-9.723 4.293 4.281zM64.72 59.562v8.086h-8.104zM52.65 36.641l-3.47 3.46-3.47-3.46zm-10.908 0-8.101 8.083v-8.083zM72.36 75.27H41.28v-2.172h9.946a.82.82 0 0 0 0-1.64H37.459v-2.17H65.54a.82.82 0 0 0 .82-.82V40.45h2.178v31.008h-9.946a.82.82 0 0 0 0 1.64H69.36a.82.82 0 0 0 .82-.82V44.262h2.18z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.91 71.457a.82.82 0 0 0 0 1.64h.003a.82.82 0 1 0-.003-1.64",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.771 35.82v32.65a.23.23 0 0 1-.23.23H32.82a.24.24 0 0 1-.23-.231V35.82a.23.23 0 0 1 .23-.23h32.721c.12 0 .23.11.23.23Z",
    fill: "#fff",
    stroke: "#E5A033",
    strokeWidth: 1.181
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32 35h42v42H32z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.815332 0 0 0 0 0.815332 0 0 0 0 0.815332 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4050_20221"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4050_20221",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlanOnboarding2);
export default __webpack_public_path__ + "static/media/ic_plan_onboarding_2.1c858ed77d549b9fda26a433f355db05.svg";
export { ForwardRef as ReactComponent };